"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateEvaluator = void 0;
const BaseAggregateEvaluator_1 = require("./BaseAggregateEvaluator");
const SyncEvaluator_1 = require("./SyncEvaluator");
// TODO: Support hooks & change name to SyncAggregateEvaluator
class AggregateEvaluator extends BaseAggregateEvaluator_1.BaseAggregateEvaluator {
    constructor(expr, config, throwError) {
        super(expr, throwError);
        this.evaluator = new SyncEvaluator_1.SyncEvaluator(expr.expression, config);
    }
    put(bindings) {
        this.init(bindings);
    }
    __put(bindings) {
        try {
            const term = this.evaluator.evaluate(bindings);
            this.state = this.aggregator.put(this.state, term);
        }
        catch (error) {
            this.safeThrow(error);
        }
    }
    safeThrow(err) {
        if (this.throwError) {
            throw err;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.put = () => { };
            // eslint-disable-next-line unicorn/no-useless-undefined
            this.result = () => undefined;
        }
    }
    init(start) {
        try {
            const startTerm = this.evaluator.evaluate(start);
            this.state = this.aggregator.init(startTerm);
            if (this.state) {
                this.put = this.__put.bind(this);
                this.result = this.__result.bind(this);
            }
        }
        catch (error) {
            this.safeThrow(error);
        }
    }
}
exports.AggregateEvaluator = AggregateEvaluator;
//# sourceMappingURL=AggregateEvaluator.js.map